import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import UISelect from 'UIComponents/input/UISelect';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import virtualizedMenuRenderer from 'UIComponents/input/utils/virtualizedMenuRenderer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTimezoneGroupSelectOptions } from '../../utils/timezoneUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimezoneEditor = ({
  tz,
  setTZ,
  tzAutoUpdateEnabled,
  setTzAutoUpdateEnabled,
  showTzAutoUpdateCheckbox
}) => {
  const tzList = getTimezoneGroupSelectOptions();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISelect, {
      "data-test-id": "timezone-select",
      className: "m-top-4 m-bottom-1",
      onChange: ({
        target: {
          value
        }
      }) => {
        setTZ(value);
      },
      value: tz,
      options: tzList
      // Timezone is determined by location in this case
      ,
      disabled: tzAutoUpdateEnabled
      //This will be done when we migrate UISelect, thread with context here: https://hubspot.slack.com/archives/C1WG3L3J6/p1740674839427109
      ,
      menuRenderer: virtualizedMenuRenderer
    }), showTzAutoUpdateCheckbox && /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "timezone-auto-update-checkbox",
      "data-test-value": tzAutoUpdateEnabled,
      checked: tzAutoUpdateEnabled,
      onChange: ({
        target: {
          checked
        }
      }) => setTzAutoUpdateEnabled(checked),
      description: /*#__PURE__*/_jsx(UIHelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.timezoneModal.timezoneAutoUpdate.helperText"
        })
      }),
      descriptionLayout: "horizontal",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-asset-management-lib.timezoneModal.timezoneAutoUpdate.label"
      })
    })]
  });
};
export default TimezoneEditor;